<template>
  <div class="additional-exhibitors-manager">
    <div class="section-header">
      <h3>{{ t.additional_exhibitors }}</h3>
      <p class="pricing-info">{{ t.extra_exhibitors_cost }}</p>
    </div>
    
    <div class="exhibitors-list">
      <AdditionalExhibitorForm
        v-for="(exhibitor, index) in additionalExhibitors"
        :key="exhibitor.id"
        :exhibitor="exhibitor"
        :index="index"
        @update="updateExhibitor"
        @remove="removeExhibitor"
      />
    </div>
    
    <div class="add-exhibitor-section">
      <button 
        type="button" 
        @click="addExhibitor" 
        class="add-button"
        :title="t.add_exhibitor"
      >
        <span class="plus-icon">+</span>
        {{ t.add_exhibitor }}
      </button>
    </div>
    
  </div>
</template>

<script>
import { computed } from 'vue';
import AdditionalExhibitorForm from './AdditionalExhibitorForm.vue';
import useReservationData from '@/composables/useReservationData';
import useTexts from '@/composables/useTexts';

export default {
  name: 'AdditionalExhibitorsManager',
  components: {
    AdditionalExhibitorForm
  },
  setup() {
    const { 
      reservationData, 
      addAdditionalExhibitor, 
      removeAdditionalExhibitor, 
      updateAdditionalExhibitor
    } = useReservationData();
    
    const { getTextsForComponent } = useTexts();
    const t = getTextsForComponent('AdditionalExhibitorsManager');

    const additionalExhibitors = computed(() => reservationData.value.additionalExhibitors);

    const addExhibitor = () => {
      addAdditionalExhibitor();
    };

    const removeExhibitor = (id) => {
      removeAdditionalExhibitor(id);
    };

    const updateExhibitor = (id, field, value) => {
      updateAdditionalExhibitor(id, field, value);
    };

    return {
      additionalExhibitors,
      addExhibitor,
      removeExhibitor,
      updateExhibitor,
      t
    };
  }
};
</script>

<style scoped>
.additional-exhibitors-manager {
  margin-top: 30px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.section-header {
  margin-bottom: 20px;
}

.section-header h3 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 1.3em;
}

.pricing-info {
  margin: 0;
  color: #666;
  font-style: italic;
  font-size: 0.9em;
}

.exhibitors-list {
  margin-bottom: 20px;
}

.add-exhibitor-section {
  text-align: center;
  margin-bottom: 20px;
}

.add-button {
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s;
}

.add-button:hover {
  background: #218838;
}

.plus-icon {
  font-size: 18px;
  font-weight: bold;
}


@media (max-width: 768px) {
  .additional-exhibitors-manager {
    padding: 15px;
  }
  
  .add-button {
    width: 100%;
    justify-content: center;
  }
}
</style>